module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/btn_4_sp_6e90a8c2fe79bee3dade7af347b1b0e0.png";